//Modules
import React, { useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import gsap from 'gsap';
import { useTransition } from '../globalComponents/PageTransitionContext';

//Styles
import './MenuPage.css';

export const MenuPage = ({ onClose }) => {
    const { handleNavigation } = useTransition();
    const location = useLocation();
    const overlayRef = useRef(null);
    const itemsRef = useRef([]);

    const navItems = [
        { name: 'Home', path: '/' },
        { name: 'About Me', path: '/AboutMe' },
        { name: 'Other Stuff', path: '/OtherStuff' },
        { name: 'Contact', path: '/ContactMe' },
    ];

    useEffect(() => {
        gsap.fromTo(
            overlayRef.current,
            { clipPath: "inset(0% 0% 100% 0%)" },
            {
                clipPath: "inset(0% 0% 0% 0%)",
                duration: 0.6,
                ease: "power2.inOut",
                onComplete: () => {
                    gsap.fromTo(
                        itemsRef.current,
                        { opacity: 0, y: 30 },
                        {
                            opacity: 1,
                            y: 0,
                            duration: 0.5,
                            stagger: 0.08,
                            ease: "power3.out",
                        }
                    );
                }
            }
        );
    }, []);

    return(
        <div className="menu-overlay" ref={overlayRef}> 
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="close-icon" onClick={onClose}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
            </svg>
            <nav className="mobile-menu">
                {navItems.map((item, index) => {
                    const isActive = location.pathname === item.path;
                    return (
                        <Link
                            key={index}
                            ref={el => itemsRef.current[index] = el}
                            className={`mobile-menu-item heading-3 ${isActive ? 'active' : ''}`}
                            to={item.path}
                            onClick={(e) => {
                                if (!isActive) {
                                    e.preventDefault();
                                    onClose();
                                    handleNavigation(item.path);
                                }
                            }}
                            style={isActive ? { pointerEvents: 'none' } : {}}
                        >
                            {item.name}
                        </Link>
                    );
                })}
            </nav> 
        </div>
    )
};